module.exports = __webpack_public_path__ + "media/videos/new_welcome_video-8522eb88767cc892e93a82cd1ba9a142.mp4";